const QUOTES = [
  { text: "The secret of getting ahead is getting started.", author: "Mark Twain" },
  { text: "It always seems impossible until it's done.", author: "Nelson Mandela" },
  { text: "Well begun is half done.", author: "Aristotle" },
  { text: "Focus on being productive instead of busy.", author: "Tim Ferriss" },
  { text: "Do what you can, with what you have, where you are.", author: "Theodore Roosevelt" },
  { text: "Action is the foundational key to all success.", author: "Pablo Picasso" },
  { text: "Don't watch the clock; do what it does. Keep going.", author: "Sam Levenson" },
  { text: "The way to get started is to quit talking and begin doing.", author: "Walt Disney" },
  { text: "Quality is not an act, it is a habit.", author: "Aristotle" },
  { text: "Discipline is choosing between what you want now and what you want most.", author: "Abraham Lincoln" },
  { text: "What gets measured gets managed.", author: "Peter Drucker" },
  { text: "Start where you are. Use what you have. Do what you can.", author: "Arthur Ashe" },
  { text: "Done is better than perfect.", author: "Sheryl Sandberg" },
  { text: "Either you run the day or the day runs you.", author: "Jim Rohn" },
  { text: "The future depends on what you do today.", author: "Mahatma Gandhi" },
  { text: "Whether you think you can or you think you can't, you're right.", author: "Henry Ford" },
  { text: "You don't have to be great to start, but you have to start to be great.", author: "Zig Ziglar" },
  { text: "Efficiency is doing things right; effectiveness is doing the right things.", author: "Peter Drucker" },
  { text: "If you want to lift yourself up, lift up someone else.", author: "Booker T. Washington" },
  { text: "Great things are done by a series of small things brought together.", author: "Vincent van Gogh" },
  { text: "Simplicity is the ultimate sophistication.", author: "Leonardo da Vinci" },
  { text: "Make each day your masterpiece.", author: "John Wooden" },
  { text: "The only way to do great work is to love what you do.", author: "Steve Jobs" },
  { text: "Strive not to be a success, but rather to be of value.", author: "Albert Einstein" },
  { text: "Opportunities don't happen. You create them.", author: "Chris Grosser" },
  { text: "Be so good they can't ignore you.", author: "Steve Martin" },
  { text: "We are what we repeatedly do.", author: "Will Durant" },
  { text: "Stay hungry. Stay foolish.", author: "Stewart Brand" },
  { text: "You miss 100% of the shots you don't take.", author: "Wayne Gretzky" },
  { text: "Believe you can and you're halfway there.", author: "Theodore Roosevelt" },
  { text: "If you're going through hell, keep going.", author: "Winston Churchill" },
  { text: "Fall seven times and stand up eight.", author: "Japanese Proverb" },
  { text: "A goal without a plan is just a wish.", author: "Antoine de Saint-Exupéry" },
  { text: "Energy and persistence conquer all things.", author: "Benjamin Franklin" },
  { text: "Never confuse movement with action.", author: "Ernest Hemingway" },
  { text: "Plans are nothing; planning is everything.", author: "Dwight D. Eisenhower" },
  { text: "You can do anything, but not everything.", author: "David Allen" },
  { text: "You do not rise to the level of your goals. You fall to the level of your systems.", author: "James Clear" },
  { text: "Every action you take is a vote for the type of person you wish to become.", author: "James Clear" },
  { text: "Deep work is rare, valuable, and meaningful.", author: "Cal Newport" },
  { text: "Say no to the good so you can say yes to the best.", author: "John C. Maxwell" },
  { text: "If everything is important, then nothing is.", author: "Patrick Lencioni" },
  { text: "Don't break the chain.", author: "Jerry Seinfeld" },
  { text: "A year from now you may wish you had started today.", author: "Karen Lamb" },
  { text: "The best time to plant a tree was 20 years ago. The second best time is now.", author: "Chinese Proverb" },
  { text: "Hard work beats talent when talent doesn't work hard.", author: "Tim Notke" },
  { text: "Dream big. Start small. Act now.", author: "Robin Sharma" },
  { text: "Success usually comes to those who are too busy to be looking for it.", author: "Henry David Thoreau" },
  { text: "Don't be afraid to give up the good to go for the great.", author: "John D. Rockefeller" },
  { text: "The expert in anything was once a beginner.", author: "Helen Hayes" },
  { text: "Do the hard jobs first. The easy jobs will take care of themselves.", author: "Dale Carnegie" },
  { text: "Inspiration exists, but it has to find you working.", author: "Pablo Picasso" },
  { text: "Concentrate all your thoughts upon the work at hand.", author: "Alexander Graham Bell" },
  { text: "I have not failed. I've just found 10,000 ways that won't work.", author: "Thomas Edison" },
  { text: "Lost time is never found again.", author: "Benjamin Franklin" },
  { text: "Time is what we want most, but what we use worst.", author: "William Penn" },
  { text: "The shorter way to do many things is to only do one thing at a time.", author: "Mozart" },
  { text: "Work expands to fill the time available for its completion.", author: "C. Northcote Parkinson" },
  { text: "Make it so easy you can't say no.", author: "Leo Babauta" },
  { text: "Environment is the invisible hand that shapes behavior.", author: "James Clear" },
  { text: "The successful warrior is the average person, with laser-like focus.", author: "Bruce Lee" },
  { text: "Ordinary people think merely of spending time; great people think of using it.", author: "Arthur Schopenhauer" },
  { text: "Amateurs sit and wait for inspiration, the rest of us just get up and go to work.", author: "Stephen King" },
  { text: "If there is no struggle, there is no progress.", author: "Frederick Douglass" },
  { text: "Success is the sum of small efforts, repeated day in and day out.", author: "Robert Collier" },
  { text: "The most effective way to do it is to do it.", author: "Amelia Earhart" },
  { text: "Do not wait to strike till the iron is hot; make it hot by striking.", author: "William Butler Yeats" },
  { text: "The reward for work well done is the opportunity to do more.", author: "Jonas Salk" },
  { text: "To improve is to change; to be perfect is to change often.", author: "Winston Churchill" },
  { text: "The best preparation for good work tomorrow is good work today.", author: "Elbert Hubbard" },
  { text: "Nothing will work unless you do.", author: "Maya Angelou" },
  { text: "Small deeds done are better than great deeds planned.", author: "Peter Marshall" },
  { text: "The great aim of education is not knowledge but action.", author: "Herbert Spencer" },
  { text: "Don't wait. The time will never be just right.", author: "Napoleon Hill" },
  { text: "The key is not to prioritize what's on your schedule, but to schedule your priorities.", author: "Stephen Covey" },
  { text: "Your mind is for having ideas, not holding them.", author: "David Allen" },
  { text: "Clarity affords focus.", author: "Thomas Leonard" },
  { text: "The main thing is to keep the main thing the main thing.", author: "Stephen Covey" },
  { text: "Nothing is less productive than to make more efficient what should not be done at all.", author: "Peter Drucker" },
  { text: "Act as if what you do makes a difference. It does.", author: "William James" },
  { text: "Perseverance is not a long race; it is many short races one after another.", author: "Walter Elliot" },
  { text: "Motivation is what gets you started. Habit is what keeps you going.", author: "Jim Rohn" },
  { text: "The beginning is always today.", author: "Mary Shelley" },
  { text: "If you spend too much time thinking about a thing, you'll never get it done.", author: "Bruce Lee" },
  { text: "Progress is impossible without change.", author: "George Bernard Shaw" },
];

const hashString = (value) => {
  let hash = 0;
  const str = String(value || "");
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getQuoteOfTheDay = (userId, date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const key = `${userId || "guest"}-${year}-${month}-${day}`;
  const index = hashString(key) % QUOTES.length;
  return QUOTES[index];
};

export default QUOTES;
